import e from "./SchemaGlyphPuck.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/SchemaGlyphPuck.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaGlyphPuck.vue.js.map